export default __webpack_public_path__ + "assets/primaryWhatsapp.78d48146.svg";